import FeaturesBody from './FeaturesBody';

export default FeaturesBody;
